import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Heading, Link, Stack, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { Seo } from '../components/Seo';
import { Eyebrow } from '../components/Section';
import { footerLinks } from '../data/site';
export function NotFound() {
  return <>
      <Seo title="Page Not Found | Futuramy Investment LLC" description="The page you requested could not be found on the Futuramy Investment LLC website." path="/404" data-id="element-266" data-mp="1560oqeb4w7wi" />
      <Box bg="navy.50" borderBottom="1px solid" borderColor="navy.100" data-id="element-267" data-mp="1f23qhj22q4ix">
        <Container maxW="1200px" px={{
        base: 6,
        md: 8
      }} py={{
        base: 20,
        md: 32
      }} data-id="element-268" data-mp="1ju3y7xody1q2">
          <Box maxW="640px" data-id="element-269" data-mp="1nvfo84b68oys">
            <Eyebrow data-id="element-270" data-mp="1nvp614m2bpte">Error 404</Eyebrow>
            <Heading as="h1" fontSize={{
            base: '3xl',
            md: '5xl'
          }} lineHeight={1.15} data-id="element-271" data-mp="1nunrgq5u8l6x">
              This page could not be found.
            </Heading>
            <Text mt={6} fontSize={{
            base: 'md',
            md: 'lg'
          }} color="navy.500" fontWeight={300} data-id="element-272" data-mp="1xt3hsqx1jqfd">
              The page you requested may have been moved or is no longer available. You can return to
              the homepage or continue to one of the sections below.
            </Text>
            <Stack direction={{
            base: 'column',
            sm: 'row'
          }} spacing={4} mt={10} data-id="element-273" data-mp="1euw124k67ae1">
              <Button as={RouterLink} to="/" variant="solidNavy" size="lg" data-id="element-274" data-mp="1ex0djaw4xhpx">
                Return Home
              </Button>
              <Button as={RouterLink} to="/contact" variant="outlineNavy" size="lg" data-id="element-275" data-mp="26mv41avqbdg6">
                Contact Us
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} py={{
      base: 12,
      md: 16
    }} data-id="element-276" data-mp="1xti77xujnrot">
        <Text fontSize="xs" fontWeight={600} letterSpacing="0.16em" textTransform="uppercase" color="navy.400" mb={5} data-id="element-277" data-mp="1sv6thc14ox1b">
          Site Sections
        </Text>
        <Wrap spacing={6} data-id="element-278" data-mp="2qbnfp62kmfvt">
          {footerLinks.map(item => <WrapItem key={item.to} data-id="element-279" data-mp="2likvvpnlikst">
              <Link as={RouterLink} to={item.to} fontSize="sm" color="navy.600" _hover={{
            color: 'accent.600',
            textDecoration: 'none'
          }} data-id="element-280" data-mp="2lhj76idnpzsm">
                {item.label}
              </Link>
            </WrapItem>)}
        </Wrap>
      </Container>
    </>;
}